import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

const CardTitle = ({ data, long = false, options = {} }) => {
  const { header = 1 } = options;
  const { image } = data;

  const headerMap = {
    1: 'type1',
    2: 'type2',
    3: 'type3',
  };
  return (
    <div className={`title ${long ? 'long' : ''}`}>
      <div className={`header ${headerMap[header]} ${long ? 'long' : ''}`}>
        {data.header}
      </div>
      {image && (
        <div className={`image ${headerMap[header]} ${long ? 'long' : ''}`}>
          <GatsbyImage alt="" image={getImage(image)} />
        </div>
      )}
    </div>
  );
};
CardTitle.propTypes = {
  data: PropTypes.object,
  long: PropTypes.bool,
  options: PropTypes.object,
};
export default CardTitle;
